// btw-front/src/components/ui/EmptyState.jsx
import React from "react";

export function EmptyState({ icon, title, desc, cta, className = "" }) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-slate-200 bg-slate-50/50 px-6 py-10 text-center ${className}`}
    >
      {icon && (
        <div aria-hidden="true" className="text-3xl">
          {icon}
        </div>
      )}
      {title && <h3 className="text-sm font-semibold text-slate-800">{title}</h3>}
      {desc && <p className="max-w-sm text-xs leading-relaxed text-slate-500">{desc}</p>}
      {cta && <div className="mt-2">{cta}</div>}
    </div>
  );
}
